module.exports = __webpack_public_path__ + "img/blue-rectangle-table-4.205e188c.png";